export default __webpack_public_path__ + "static/media/two_col_layout.278a9580.svg";